/**
 * 画像ファイル形式の判定・変換ユーティリティ
 *
 * BMP はサーバー側で受け付けていないため、アップロード前にブラウザで PNG に変換する。
 */

// ブラウザ・OS によって BMP の MIME タイプ表記が揺れる
const BMP_MIME_TYPES = new Set(['image/bmp', 'image/x-bmp', 'image/x-ms-bmp']);

/** input の accept 属性に指定する値（PNG / JPEG / BMP） */
export const IMAGE_UPLOAD_ACCEPT = 'image/png,image/jpeg,image/jpg,image/bmp,.bmp';

/**
 * BMP ファイルかどうかを判定する。
 * MIME タイプが空で渡される環境があるため、その場合は拡張子で判定する。
 */
export const isBmpFile = (file: File): boolean =>
  BMP_MIME_TYPES.has(file.type) || (file.type === '' && /\.bmp$/i.test(file.name));

/**
 * BMP ファイルを PNG ファイルに変換する（ファイル名の拡張子も .png に置き換える）
 */
export const convertBmpToPng = async (file: File): Promise<File> => {
  const bitmap = await createImageBitmap(file);
  try {
    const canvas = document.createElement('canvas');
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('canvas の 2D コンテキストを取得できません');
    }
    ctx.drawImage(bitmap, 0, 0);

    const blob = await new Promise<Blob | null>((resolve) => {
      canvas.toBlob(resolve, 'image/png');
    });
    if (!blob) {
      throw new Error('PNG への変換に失敗しました');
    }

    const fileName = `${file.name.replace(/\.[^.]+$/, '')}.png`;
    return new File([blob], fileName, { type: 'image/png' });
  } finally {
    bitmap.close();
  }
};
